import React from 'react'
import PropTypes from 'prop-types'

import noAccess from 'assets/gifs/noAccess.gif'

const EmptyState = ({ label }) => {
  return (
    <section className="empty-state">
      <img alt="space rocket launch" className="empty-state__graphic" src={noAccess} />
      <p className="empty-state__label">{label}</p>
    </section>
  )
}

EmptyState.propTypes = {
  label: PropTypes.string,
}

export default EmptyState
